import {
  Avatar,
  Container,
  CssBaseline,
  Grid,
  makeStyles,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@material-ui/core";
import React, { useEffect } from "react";
import SettingsIcon from "@material-ui/icons/Settings";
import Alert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import { CKEditor } from "../../components";
import { invokeApi } from "../../bl_libs/ApiCalling";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    alignItems: "center",
  },
  button: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    // margin: theme.spacing(1),
    // minWidth: 220,
    width: "100%",
  },
  uploadroot: {
    "& > *": {
      marginTop: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
}));

function Settings() {
  const classes = useStyles();
  const [errMessage, setErrMessage] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(true);
  const [isDisable, setIsDisable] = React.useState(true);
  const [inputs, setInputs] = React.useState({
    about: "",
    contact_us: "",
    faq: "",
    how_evom_work: "",
    cancellation_policy: "",
    legal: "",
    terms_of_service: "",
    privacy_policy: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(inputs);
    if (isDisable === false) {
      UpdateSettings();
    } else {
      setIsDisable(false);
    }
  };

  const handleChangeInCkEdditor = (key, value) => {
    setInputs({
      ...inputs,
      [key]: value,
    });
  };

  const UpdateSettings = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/add_setting`,
      method: "POST",
      headers: {
        "x-sh-auth": token,
      },
    };

    let postData = {
      about: inputs.about,
      contact_us: inputs.contact_us,
      faq: inputs.faq,
      how_evom_work: inputs.how_evom_work,
      cancellation_policy: inputs.cancellation_policy,
      legal: inputs.legal,
      terms_of_service: inputs.terms_of_service,
      privacy_policy: inputs.privacy_policy,
    };

    requestObj["postData"] = postData;
    setIsLoading(true);
    invokeApi(requestObj).then((res) => {
      console.log(res, "API RES");
      if (res.code === 200) {
        setIsDisable(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  const GetSettingsData = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: `/api/admin/get_setting`,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      setInputs(res.setting_data);
      setIsLoading(false);
    });
  };

  const cleanLocalStorge = () => {
    const token = localStorage.getItem("token");
    localStorage.clear();
    localStorage.setItem("token", token);
  };

  useEffect(() => {
    GetSettingsData();
    return () => {
      cleanLocalStorge();
    };
  }, []);

  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress />
      </div>
    );
  }
  return (
    <>
      <Container component="main" maxWidth="sm">
        <CssBaseline />

        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <SettingsIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Settings
          </Typography>
          <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={0}></Grid>
                  <Grid item xs={12}>
                    {errMessage && (
                      <Alert variant="filled" severity="error">
                        {errMessage}
                      </Alert>
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={0}></Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">About :</Typography>
                <CKEditor
                  content={inputs.about}
                  setContent={(value) => {
                    handleChangeInCkEdditor("about", value);
                  }}
                  mode={isDisable}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">Contact Us :</Typography>
                <CKEditor
                  content={inputs.contact_us}
                  setContent={(value) => {
                    handleChangeInCkEdditor("contact_us", value);
                  }}
                  mode={isDisable}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">FAQ :</Typography>
                <CKEditor
                  content={inputs.faq}
                  setContent={(value) => {
                    handleChangeInCkEdditor("faq", value);
                  }}
                  mode={isDisable}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">How LA Moving Star Works :</Typography>
                <CKEditor
                  content={inputs.how_evom_work}
                  setContent={(value) => {
                    handleChangeInCkEdditor("how_evom_work", value);
                  }}
                  mode={isDisable}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">
                  Cancellation policy :
                </Typography>
                <CKEditor
                  content={inputs.cancellation_policy}
                  setContent={(value) => {
                    handleChangeInCkEdditor("cancellation_policy", value);
                  }}
                  mode={isDisable}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">Legal :</Typography>
                <CKEditor
                  content={inputs.legal}
                  setContent={(value) => {
                    handleChangeInCkEdditor("legal", value);
                  }}
                  mode={isDisable}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">
                  Terms of Service :
                </Typography>
                <CKEditor
                  content={inputs.terms_of_service}
                  setContent={(value) => {
                    handleChangeInCkEdditor("terms_of_service", value);
                  }}
                  mode={isDisable}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography color="textSecondary">Privacy Policy :</Typography>
                <CKEditor
                  content={inputs.privacy_policy}
                  setContent={(value) => {
                    handleChangeInCkEdditor("privacy_policy", value);
                  }}
                  mode={isDisable}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              {isDisable ? (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  startIcon={<EditIcon />}
                  fullWidth
                >
                  Edit settings
                </Button>
              ) : (
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  fullWidth
                >
                  Update settings
                </Button>
              )}
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}

export default Settings;
